import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { catchError, of } from 'rxjs';
import { FeatureFlagService } from './services/feature-flag.service';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';

function initializeFeatureFlags(service: FeatureFlagService) {
  return () => service.load().pipe(catchError(() => of(null)));
}

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeFeatureFlags,
      deps: [FeatureFlagService],
      multi: true,
    },
    // Order matters. Request interceptors run in registration order and response
    // handlers unwind in reverse, so ErrorInterceptor must come FIRST to see every
    // response last. It also means its retry re-subscribes THROUGH AuthInterceptor,
    // so a retried request re-reads the token rather than replaying a stale header.
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
})
export class CoreModule {}
